// frontend/admin-portal/src/routes/domains/salesRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import { PermissionRoute } from "@fiberhome/shared-ui";

import Orders from "../../pages/Orders";
import OrderCreate from "../../pages/OrderCreate";
import OrderDetail from "../../pages/OrderDetail";
import OrderPrint from "../../pages/OrderPrint";
import Invoices from "../../pages/Invoices";
import InvoiceDetail from "../../pages/InvoiceDetail";

export default function SalesRoutes() {
  return (
    <>
      <Route element={<PermissionRoute permission="orders.read" />}>
        {/* ---- Order / offer listing + create ---- */}
        <Route path="orders" element={<Orders />} />
        <Route path="orders/new" element={<OrderCreate />} />

        {/* ---- PRINT must come BEFORE :id so it matches first ---- */}
        <Route path="orders/:id/print" element={<OrderPrint />} />

        {/* ---- Detail comes last ---- */}
        <Route path="orders/:id" element={<OrderDetail />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="invoices/:id" element={<InvoiceDetail />} />
      </Route>

      
    </>
  );
}
